import dayjs from '../../utils/dayjsConfig'
import { escapeCsvValue } from '../../helpers/utils'

const statusLabel = (user) => {
  if (user.status === 'inactive') return 'INACTIVO'
  if (user.status === 'pending' || (!user.active && user.email_verified === false)) {
    return 'PENDIENTE'
  }
  return user.active || user.status === 'active' ? 'ACTIVO' : 'INACTIVO'
}

export const buildRbacUsersCsvRows = (users) => [
  ['CÓDIGO', 'NOMBRE', 'CORREO ELECTRÓNICO', 'ROL ASIGNADO', 'SESIONES', 'ÚLTIMA SESIÓN', 'ESTADO'],
  ...users.map((user) => [
    user.code || '',
    user.name || '',
    user.email || '',
    (user.roles || []).map((role) => role.name).filter(Boolean).join(' + ') || 'SIN ROL',
    user.active_sessions_count ?? 0,
    user.last_session_at && dayjs(user.last_session_at).isValid()
      ? dayjs(user.last_session_at).format('DD/MM/YYYY HH:mm:ss')
      : '',
    statusLabel(user)
  ])
]

export const downloadRbacUsersCsv = (users) => {
  const csv = buildRbacUsersCsvRows(users)
    .map((row) => row.map(escapeCsvValue).join(','))
    .join('\r\n')
  const url = URL.createObjectURL(new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8' }))
  const link = document.createElement('a')
  link.href = url
  link.download = `Usuarios_Torre_${dayjs().format('YYYY-MM-DD')}.csv`
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.setTimeout(() => URL.revokeObjectURL(url), 0)
}
